<template>
  <v-row>
    <v-col xl="8" sm="12" mr-1 class="py-0">
      <div class="bg-logo d-flex">
        <div>
          <div class="box-add-image">
            <img
              :src="imageAva"
              class="img-logo"
              @click="$refs.file.click()"
              @dragover.prevent
              @drop="onDrop"
              alt=""
            />
            <v-btn
              class="btn-uploadImg"
              @click="$refs.file.click()"
              :disabled="disabled"
              color="#E9330E"
              ><input
                class="d-none"
                ref="file"
                type="file"
                id="uploadScreens"
                accept="image/*"
                @change="uploadScreen($event)"
              />
              {{
                $t('register-page.upload-image.btn-upload-img', {
                  split: '/'
                })
              }}
            </v-btn>
            <v-btn
              class="btn-uploadImg btn-reset"
              @click="reset"
              color="#E9330E"
              v-if="urlImg !== null"
            >
              {{
                $t('register-page.upload-image.btn-clear-img', {
                  split: '/'
                })
              }}
            </v-btn>
          </div>
        </div>
        <v-dialog
          class="image-preview"
          fullscreen
          hide-overlay
          v-model="dialog"
          eager
        >
          <div class="image-preview-wrapper">
            <div class="img-wrap">
              <vue-cropper ref="cropper" v-bind="options" />
            </div>
            <div class="slider-wrapper">
              <range-slider
                class="slider"
                v-bind="sliderOptions"
                v-model="sliderValue"
              >
              </range-slider>
            </div>
            <div class="button-wrapper">
              <v-btn color="#E9330E" class="btn-cropImg" @click="getCropImage">
                {{
                  $t('register-page.crop-image.btn-save-img', {
                    split: '/'
                  })
                }}
              </v-btn>
              <v-btn color="#E9330E" class="btn-cropImg" @click="closeCrop">
                {{
                  $t('register-page.crop-image.btn-cancel-img', {
                    split: '/'
                  })
                }}
              </v-btn>
            </div>
          </div>
        </v-dialog>
        <v-overlay :value="errorImgFormat">
          <v-alert class="alert-box" type="error" v-if="errorImgFormat">
            Sorry, the uploaded file is invalid.<br />
            <v-btn
              color="#FFFFFF"
              class="closeError"
              @click="errorImgFormat = !errorImgFormat"
              >Close
            </v-btn>
          </v-alert>
        </v-overlay>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { VueCropper } from 'vue-cropper';
import RangeSlider from 'vue-range-slider';
import 'vue-range-slider/dist/vue-range-slider.css';

export default {
  components: {
    VueCropper,
    RangeSlider
  },
  props: {
    imageAva: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      errorImgFormat: false,
      dialog: false,
      image: null,
      url: null,
      urlImg: null,
      sliderOptions: {
        min: 10,
        max: 100,
        step: 1
      },
      sliderValue: 10,
      options: {
        info: false,
        img: this.url,
        full: false,
        canMove: true,
        canScale: false,
        canMoveBox: false,
        fixedBox: true,
        mode: 'cover',
        autoCropWidth: 450,
        autoCropHeight: 450,
        autoCrop: true,
        fixedNumber: [1, 1],
        fixed: true
      }
    };
  },
  methods: {
    async onDrop(event) {
      event.stopPropagation();
      event.preventDefault();
      const files = event.dataTransfer.files;
      await this.checkImg(files[0], this.imgExists);
      this.validateImgExtension(files[0]);
    },
    async uploadScreen(event) {
      const files = event.target.files;
      await this.checkImg(files[0], this.imgExists);
      this.validateImgExtension(files[0]);
    },
    checkImg(file, callback) {
      const urlImgCheck = URL.createObjectURL(file);
      const image = new Image();
      image.src = urlImgCheck;
      image.onerror = function () {
        callback(false);
      };
      image.onload = function () {
        callback(true);
      };
    },
    imgExists(exists) {
      if (exists === false) {
        this.dialog = false;
        this.errorImgFormat = true;
      }
    },
    validateImgExtension(file) {
      const validFileExtensions = ['.jpg', '.jpeg', '.bmp', '.tiff', '.png'];
      const fileName = file.name;
      if (fileName.length > 0) {
        let inValid = false;
        for (let j = 0; j < validFileExtensions.length; j++) {
          const curExtension = validFileExtensions[j];
          if (
            fileName
              .substr(fileName.length - curExtension.length)
              .toLowerCase() === curExtension.toLowerCase()
          ) {
            inValid = true;
            this.dialog = true;
            this.createFile(file);
            break;
          }
        }
        if (!inValid) {
          this.errorImgFormat = true;
          file.name = '';
          return false;
        }
      }
    },
    createFile(file) {
      this.url = URL.createObjectURL(file);
      const reader = new FileReader();
      const vm = this;
      reader.onload = function (e) {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    closeCrop() {
      this.$emit('close');
      this.dialog = false;
      this.image = null;
      this.url = null;
      this.sliderValue = 10;
      this.$refs.file.value = null;
    },
    getCropImage(type) {
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob((data) => {
          this.url = window.URL.createObjectURL(data);
          this.dialog = false;
          this.sliderValue = 10;
          this.urlImg = this.url;
          this.$refs.file.value = null;
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.url = data;
          this.dialog = false;
          this.sliderValue = 10;
          this.urlImg = this.url;
          this.$refs.file.value = null;
          this.$emit('getDataImage', this.urlImg);
        });
      }
    },
    reset() {
      this.urlImg = null;
      this.url = null;
      this.image = null;

      this.$refs.file.value = null;
      this.$emit('getDataImage', this.urlImg);
    },
    // HungPD add 2023_10_08 Start
    uplodaToS3(data) {}
    // HungPD add 2023_10_08 End
  },
  watch: {
    url: function (value) {
      if (value !== null) {
        this.options.img = this.url;
      }
    },
    urlImg: function (value) {
      if (value !== null) {
        this.imageAva = this.urlImg;
      }
    },
    sliderValue(newVal, oldVal) {
      return this.$refs.cropper.changeScale(newVal - oldVal);
    }
  }
};
</script>
<style scoped lang="scss">
.slider-wrapper {
  text-align: center;
}

.slider {
  height: 1px;
  width: 400px !important;
  max-width: 100%;
  padding-top: 20px;
  padding-bottom: 43px;
  background-color: transparent;
}

.img-logo {
  display: block;
  width: 258px;
  height: 258px;
  background: url('../assets/image/img-placeholder.jpg') no-repeat !important;
  background-size: cover !important;
  background-position-x: center;
}

button.btn-uploadImg {
  color: white;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 11px;
  margin-right: 10px;
}

button.btn-uploadImg.btn-reset {
  margin-right: 0;
}

button.btn-cropImg {
  color: white;
  width: 180px;
  margin-right: 10px;
  margin-left: 10px;
  text-transform: none;
}

@media only screen and (max-width: 414px) {
  button.btn-cropImg {
    width: 90%;
    margin: 5px 0;
  }
}

.image-preview-wrapper {
  position: absolute;
  background-color: white;
  top: 50%;
  left: 50%;
  width: 800px;
  min-width: 800px;
  min-height: 600px;
  border: solid 1px #eee;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  z-index: 99;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
  overflow-x: hidden;
}

.img-wrap {
  position: relative;
  overflow: hidden;
  margin: 13px auto 5px;
  height: 450px;
  width: 450px;
}

@media only screen and (max-width: 280px) {
  .image-preview-wrapper {
    width: 270px;
    min-width: 270px;
    min-height: 555px;
  }

  .img-wrap {
    width: 270px;
    height: 270px;
  }

  button.btn-cropImg {
    margin-right: 5px;
    margin-left: 5px;
  }

  .slider {
    height: 1px;
    width: 280px !important;
    max-width: 100%;
    padding-top: 20px;
    padding-bottom: 43px;
    background-color: transparent;
  }
}

@media only screen and (max-width: 320px) {
  .img-logo {
    width: 238px;
    height: 238px;
  }

  button.btn-uploadImg {
    width: 114px;
    font-size: 9px !important;
  }

  .slider {
    height: 1px;
    width: 280px !important;
    max-width: 100%;
    padding-top: 20px;
    padding-bottom: 43px;
    background-color: transparent;
  }
}

@media only screen and (max-width: 375px) and (min-width: 321px) {
  .img-logo {
    width: 280px;
    height: 280px;
  }

  button.btn-uploadImg {
    width: 135px;
    font-size: 11px !important;
  }

  .slider {
    height: 1px;
    width: 280px !important;
    max-width: 100%;
    padding-top: 20px;
    padding-bottom: 43px;
    background-color: transparent;
  }
}

@media only screen and (max-width: 414px) and (min-width: 376px) {
  .img-logo {
    width: 311.188px;
    height: 311.188px;
  }

  button.btn-uploadImg {
    width: 150.594px;
    font-size: 10px !important;
  }

  .slider {
    height: 1px;
    width: 280px !important;
    max-width: 100%;
    padding-top: 20px;
    padding-bottom: 43px;
    background-color: transparent;
  }
}

@media only screen and (max-width: 450px) and (min-width: 281px) {
  .image-preview-wrapper {
    width: 300px;
    min-width: 300px;
    min-height: 555px;
  }

  .img-wrap {
    width: 265px;
    height: 265px;
  }

  .slider {
    height: 1px;
    width: 280px !important;
    max-width: 100%;
    padding-top: 20px;
    padding-bottom: 43px;
    background-color: transparent;
  }
}

@media only screen and (max-width: 768px) and (min-width: 451px) {
  .image-preview-wrapper {
    width: 700px;
    min-width: 700px;
    min-height: 600px;
  }
}

.image-preview {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 800px;
  min-height: 600px;
  border: solid 1px #eee;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 5px;
  z-index: 99;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
}

.vue-cropper {
  background-image: none !important;
}

.slider-wrapper {
  text-align: center;
}

span.range-slider-rail {
  background-color: #a29d9d;
}

span.range-slider-knob {
  background-color: #bfbfbf;
  box-shadow: none;
}

.button-wrapper {
  text-align: center;
  margin-top: 10px;
}

.alert-box {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
  margin-bottom: 0;
  text-align: center;
}

.closeError {
  margin-top: 10px;
  margin-right: 35px;
  color: #000000;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  button.btn-uploadImg {
    padding: 0 !important;
  }
}
</style>
